import { Pagination, Purchase, Role, User, Company, UserProcess, Language, UserDocument, UserAsset } from '@interfaces';
import { ScheduledFileDeletion } from '../../_interfaces/scheduled-file-deletion';

export type BackOfficeState = Readonly<{
  roles: Role[];
  languages: Language[];
  companies: Company[];
  employees: User[];
  partners: Partial<User>[];
  selectedPartners: Partial<User>[];

  loading: boolean;
  errorMessage: string;

  // ############
  // USERS
  // ############

  loadingUsers: boolean;
  loadedUsersPagination: Pagination;
  errorUsersMessage: string;
  loadedUsersData: User[];
  generatingUsersReport: boolean;

  // ############
  // TRANSACTIONS
  // ############

  loadingTransactions: boolean;
  loadedTransactionsPagination: Pagination;
  errorTransactionsMessage: string;
  loadedTransactionsData: Purchase[];
  downloadingPurchaseDocument: boolean;
  generatingTransactionsReport: boolean;

  // ############
  // APPLICATIONS
  // ############

  loadingApplications: boolean;
  loadedApplicationsPagination: Pagination;
  errorApplicationsMessage: string;
  loadedApplicationsData: UserProcess[];
  generatingApplicationReport: boolean;

  // ############
  // SCHEDULED FILES DELETION
  // ############

  loadingScheduledFilesDeletion: boolean;
  loadedScheduledFilesDeletionPagination: Pagination;
  errorScheduledFilesDeletionMessage: string;
  loadedScheduledFilesDeletionData: ScheduledFileDeletion[];

  // ############
  // MANAGE ASSETS
  // ############

  loadingManageFiles: boolean;
  errorManageFilesMessage: string;
  loadedUserProcessManageFiles: {
    userDocuments: UserDocument[];
    userAssets: UserAsset[];
  };

  loadingPartners: boolean;
}>;

export const defaultPagination = {
  limit: 25,
  offset: 0,
  orderBy: 'name',
  orderDir: 'asc',
};

export const initialState: BackOfficeState = {
  roles: null,
  languages: null,
  companies: null,
  employees: null,
  partners: null,
  selectedPartners: null,

  loading: false,
  errorMessage: null,

  loadingUsers: false,
  loadedUsersPagination: { ...(defaultPagination as Pagination) },
  errorUsersMessage: null,
  loadedUsersData: [],
  generatingUsersReport: false,

  loadingTransactions: false,
  loadedTransactionsPagination: { ...(defaultPagination as Pagination) },
  errorTransactionsMessage: null,
  loadedTransactionsData: [],
  downloadingPurchaseDocument: false,
  generatingTransactionsReport: false,

  loadingApplications: false,
  loadedApplicationsPagination: { ...(defaultPagination as Pagination) },
  errorApplicationsMessage: null,
  loadedApplicationsData: [],
  generatingApplicationReport: false,

  loadingScheduledFilesDeletion: false,
  loadedScheduledFilesDeletionPagination: { ...(defaultPagination as Pagination) },
  errorScheduledFilesDeletionMessage: null,
  loadedScheduledFilesDeletionData: [],

  loadingManageFiles: false,
  errorManageFilesMessage: null,
  loadedUserProcessManageFiles: null,

  loadingPartners: false,
};
